import { useDispatch, useSelector } from 'react-redux';
import PromoCode from '../promo-code.component';
import {
  selectActivityBasedContentOffers,
  selectIsLoggedIn,
} from 'redux/user/user.selectors';
import { getOrderOffers } from 'redux/cart/cart.actions';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const CheckoutPromoCode = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const activityBasedContentOffers = useSelector(
    selectActivityBasedContentOffers,
  );
  const { t } = useTranslation();

  const validateResponse = useCallback(
    result => {
      if (!result?.offerList?.offers?.length) {
        if (!isLoggedIn) {
          return `${t('payment.promoCode.checkout.guest.emptyContent1')} ${t(
            'payment.promoCode.checkout.guest.emptyContent2',
          )}`;
        } else {
          return `${t('payment.promoCode.emptyContent1')} ${t(
            'payment.promoCode.emptyContent2',
          )}`;
        }
      }
      !!result && isLoggedIn && dispatch(getOrderOffers());
    },
    [dispatch, isLoggedIn, t],
  );

  return (
    <PromoCode
      open={open}
      handleClose={handleClose}
      validateResponse={validateResponse}
      messages={activityBasedContentOffers}
      checkoutPromoCode
    />
  );
};
export default CheckoutPromoCode;
